<template>
    <v-card v-bind="$attrs" class="reset-password-card" outlined>
        <header class="reset-password-card__header">
            <span class="reset-password-card__icon" aria-hidden="true">
                <v-icon>{{ mdiLockOutline }}</v-icon>
            </span>
            <div class="reset-password-card__copy">
                <span class="reset-password-card__eyebrow">ACCOUNT SECURITY</span>
                <h3>Change password</h3>
                <p>Update your password to help keep your account secure.</p>
            </div>
        </header>

        <div v-if="state === 0" class="reset-password-card__start">
            <span class="reset-password-card__hint">You’ll need your current password to continue.</span>
            <v-btn class="reset-password-card__action" color="primary" @click="advanceState">Update password</v-btn>
        </div>

        <edit-password v-else-if="state === 1" :user-id="userId" @change-success="success" @cancel="state = 0" />

        <div v-else-if="state === 2" class="reset-password-card__success" role="status" aria-live="polite">
            <span class="reset-password-card__success-icon" aria-hidden="true">
                <v-icon>{{ mdiCheck }}</v-icon>
            </span>
            <div>
                <strong>Password updated</strong>
                <p>Your account password was changed successfully.</p>
            </div>
        </div>
    </v-card>
</template>

<script>
import EditPassword from './edit_password'
import { mdiCheck, mdiLockOutline } from '@mdi/js'
import Vue from 'vue'

export default Vue.extend({
    name: `ResetPassword`,
    components: {
        EditPassword
    },
    props: {
        userId: {
            type: String,
            required: true
        }
    },

    data: () => ({
        state: 0,
        mdiCheck,
        mdiLockOutline
    }),

    methods: {
        success() {
            this.state = 2
            const self = this
            setTimeout(() => {
                self.state = 0
            }, 7000)
        },
        advanceState() {
            if (this.state !== 2) this.state++
        }
    }
})
</script>

<style scoped>
.reset-password-card {
    overflow: hidden;
    border-radius: 9px;
}
.reset-password-card.theme--dark {
    color: #f1f2f5;
    background: rgba(23, 25, 31, 0.38);
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    box-shadow: none !important;
}
.reset-password-card__header {
    display: flex;
    align-items: center;
    gap: 11px;
    padding: 16px 18px 14px;
}
.reset-password-card.theme--dark .reset-password-card__header {
    background: linear-gradient(110deg, rgba(219, 81, 32, 0.1), transparent 75%);
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.reset-password-card__icon {
    display: grid;
    width: 36px;
    height: 36px;
    flex: 0 0 36px;
    color: #fff;
    background: #db5120;
    border-radius: 10px;
    place-items: center;
}
.reset-password-card__icon .v-icon {
    color: inherit;
    font-size: 19px;
}
.reset-password-card__copy {
    min-width: 0;
}
.reset-password-card__eyebrow {
    color: #b84820;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 1.2px;
}
.reset-password-card.theme--dark .reset-password-card__eyebrow {
    color: #f2a58b;
}
.reset-password-card__copy h3 {
    margin: 3px 0 2px;
    color: inherit;
    font-size: 15px;
    font-weight: 600;
}
.reset-password-card__copy p {
    margin: 0;
    color: #747985;
    font-size: 10px;
    line-height: 1.5;
}
.reset-password-card.theme--dark .reset-password-card__copy p {
    color: #aeb5c3;
}
.reset-password-card__start {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    padding: 14px 18px 16px;
}
.reset-password-card__hint {
    color: #747985;
    font-size: 11px;
    line-height: 1.5;
}
.reset-password-card.theme--dark .reset-password-card__hint {
    color: #aeb5c3;
}
.reset-password-card__action.v-btn {
    min-height: 36px;
    padding: 0 14px;
    color: #fff;
    background: #db5120;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.15px;
    text-transform: none;
}
.reset-password-card__action.v-btn:hover {
    background: #e76638;
}
.reset-password-card__success {
    display: flex;
    align-items: center;
    gap: 11px;
    margin: 14px 18px 16px;
    padding: 12px;
    color: #ddf5e5;
    background: rgba(63, 177, 108, 0.1);
    border: 1px solid rgba(88, 201, 135, 0.23);
    border-radius: 7px;
}
.reset-password-card__success-icon {
    display: grid;
    width: 30px;
    height: 30px;
    flex: 0 0 30px;
    color: #8addaa;
    background: rgba(88, 201, 135, 0.12);
    border-radius: 50%;
    place-items: center;
}
.reset-password-card__success-icon .v-icon {
    color: inherit;
    font-size: 18px;
}
.reset-password-card__success strong {
    font-size: 11px;
}
.reset-password-card__success p {
    margin: 2px 0 0;
    color: #b7d8c1;
    font-size: 10px;
}
@media (max-width: 480px) {
    .reset-password-card__start {
        align-items: stretch;
        flex-direction: column;
    }
}
</style>
